import { ReactNode } from 'react';

export const Column = ({ children }: { children: ReactNode }) => {
	return <div style={{ display: 'flex', flexDirection: 'column' }}>{children}</div>;
};
